import {
  inject,
  Pipe,
  PipeTransform
} from '@angular/core';
import {
  DomSanitizer,
  SafeHtml
} from '@angular/platform-browser';

@Pipe({
  standalone: true,
  name: 'byPassUrl'
})
export class ByPassPipeUrl implements PipeTransform {
  sanitizer = inject(DomSanitizer);

  transform(url: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
